export function shouldIgnoreVersionNavKeyboard(e: KeyboardEvent): boolean {
  const target = e.target as HTMLElement | null;
  if (!target) return false;

  const tag = target.tagName?.toLowerCase();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
  if (target.isContentEditable) return true;
  if (target.closest('.ant-select-dropdown, .ant-modal-wrap, .ant-drawer')) return true;
  if (e.ctrlKey || e.metaKey || e.altKey) return true;

  return false;
}
